import { INITIAL_STATE, setGoals, addGoal, deleteGoal, deleteGoalByTeamId } from '../core'
import {
    RECEIVE_GOALS,
    RECEIVE_GOAL,
    REMOVE_GOAL,
    REMOVE_GOAL_BY_TEAM_ID,
} from '../action_creators'

function toReduxGoalShape(apiGoal) {
    const { tags=[], users=[], ...rest} = apiGoal
    const reduxTags = Array.isArray(tags) ? tags : [tags]
    const reduxUsers = Array.isArray(users) ? users : [users]
    const startDate = rest.startDate * 1000
    const endDate = rest.endDate ? rest.endDate * 1000 : undefined
    const createdAt = rest.createdAt ? rest.createdAt * 1000 : undefined
    const updatedAt = rest.updatedAt ? rest.updatedAt * 1000 : undefined
    return {
        ...rest,
        startDate,
        endDate,
        createdAt,
        updatedAt,
        tags: reduxTags,
        users: reduxUsers,
    }
}
function goals(state=INITIAL_STATE.goals, action) {
    switch (action.type) {
        case RECEIVE_GOALS:
            // handle v1 actions calling "RECEIVE_GOALS" with a single goal
            if (Array.isArray(action.goals)) {
                const reduxGoals = action.goals.map( goal => toReduxGoalShape(goal))
                return setGoals(state, reduxGoals)
            } else {
                return addGoal(state, toReduxGoalShape(action.goals))
            }
        case RECEIVE_GOAL:
            return addGoal(state, toReduxGoalShape(action.goal))
        case REMOVE_GOAL:
            return deleteGoal(state, toReduxGoalShape(action.goal))
        case REMOVE_GOAL_BY_TEAM_ID:
            return deleteGoalByTeamId(state, action.teamId)
        default:
            return state
    }
}

export default goals



// WEBPACK FOOTER //
// ./src/redux/reducers/goals_reducer.js